<template>
  <!-- 法律条例 -->
  <div id="tiaoli">
    <section class="tiaolibanner"><tiaolibanner :list="axx" /></section>
    <section><tiaolimenu :tlmenuL="tlmenuL" /></section>

    <section v-for="(item, index) in tlmenuL" :key="index">
      <tiaoartic :colitem="item" />
      <section v-if="index % 2 == 0" class="hfbn">
        <img src="../../assets/jpcol/zyrzlgw.png" />
      </section>
    </section>

    <!-- 民商法类 -->
    <!-- <section><tiaoartic /></section> -->
    <!-- 行政法类 -->
    <!-- <section><tiaoartic /></section> -->
    <!-- <section class="hfbn"><img src="../../assets/jpcol/zyrzlgw.png" /></section> -->
    <!-- 经济法类 -->
    <!-- <section><tiaoartic /></section> -->
    <!-- 社会法类 -->
    <!-- <section><tiaoartic /></section> -->
    <!-- <section class="hfbn"><img src="../../assets/jpcol/zyrzlgw.png" /></section> -->
    <!-- 刑法类 -->
    <!-- <section><tiaoartic /></section> -->
    <!-- 国际法类 -->
    <!-- <section><tiaoartic /></section> -->
  </div>
</template>

<script>
import tiaolibanner from "./child/tiaolibanner"; //条例banner表单
import tiaolimenu from "./child/tiaolimenu"; //条例菜单
import tiaoartic from "./child/tiaoartic"; //文章列表

export default {
  name: "tiaoli",
  components: {
    // 私
    tiaolibanner,
    tiaolimenu,
    tiaoartic,
  },
  data() {
    return {
      tlmenuL: [],
      axx:[],
    };
  },
  beforeMount() {
    this.getmenulist();
    this.getswi()
  },
  methods: {
    getmenulist() {
      this.$http.jpcol.gettiaoliify().then((res) => {
        this.tlmenuL = res.data;
      });
    },
    getswi() {
      let data = {
        page: 1,
        limit: 3,
        order: "hot",
      };
      this.$http.jpcol.gettiaolilist(data).then((res) => {
        this.axx = res.data.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#tiaoli {
  background-color: #fff;
  .tiaolibanner {
    margin: 0 auto;
    height: 430px;
    background: url("../../assets/jpcol/tiaomubannerbg.png");
  }
  .hfbn {
    margin: 0 auto;
    width: 1200px;
    img {
      width: 100%;
    }
  }
}
</style>